// removed by extract-text-webpack-plugin
module.exports = {"campaign-segment-option":"campaign-segment-option---cHZ01"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/campaign/NewCampaign/SegmentOptionRow/style.styl
// module id = QXt5
// module chunks = 89